import * as CL from '@design-system/component-library';
import { dsClass } from '../../common/constants/dsClasses';
import { alvZeroMsg, monthlyChargesMsg, oneTimeChargeMsg, t, totalMsg } from '../../common/i18n/index.js';
import { eurosToCents, formatSum } from '../../common/utils/priceUtils.js';
import { StickyFooter } from '../StickyFooter';

import './DeviceDetailsFooterCoCo.scss';

interface PublicDeviceDetailsFooterCoCoProps {
  price?: number;
  priceUnit?: string;
  oneTimeCharge?: number;
  onAddToCart: () => void;
}

export const DeviceDetailsFooterCoCo = ({
  price,
  priceUnit = '€',
  oneTimeCharge,
  onAddToCart,
}: PublicDeviceDetailsFooterCoCoProps) => {
  const hasMonthlyCharge = price !== undefined;

  const monthlyChargeText =
    price === undefined ? undefined : `${t.P6BC(monthlyChargesMsg)}: ${formatSum(eurosToCents(price), true) ?? ''}`;

  const oneTimeChargeText =
    oneTimeCharge === undefined
      ? undefined
      : `${t.ASEI(oneTimeChargeMsg)}: ${formatSum(eurosToCents(oneTimeCharge), true) ?? ''}`;

  return (
    <StickyFooter active className="of-public-device-details-footer high-mobile">
      <CL.Grid>
        <div className="of-public-device-details-footer__content">
          <div>
            <div className="of-public-device-details-footer__price">
              {monthlyChargeText && <CL.Price currentPrice={monthlyChargeText} currentPriceUnit={priceUnit} />}
              {oneTimeChargeText && (
                <div
                  className={`${dsClass.PADDING_BOTTOM_2} of-public-device-details-footer__one-time-charge${
                    hasMonthlyCharge ? ' of-public-device-details-footer__one-time-charge--secondary' : ''
                  }`}
                >
                  <CL.Price currentPrice={oneTimeChargeText} currentPriceUnit="€" />
                </div>
              )}
            </div>
            <span>{`${t.CEQ2(totalMsg)} (${t.S8TX(alvZeroMsg)})`}</span>
          </div>
          <div className="of-public-device-details-footer__actions">
            <CL.Button onClick={onAddToCart} size="l">
              {t.B5J1('Add to basket')}
            </CL.Button>
          </div>
        </div>
      </CL.Grid>
    </StickyFooter>
  );
};
